/** @jsxRuntime classic*/
/** @jsx _j */
/** @jsxFrag _j.F */

import _j from "astroturf/jsx";
const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { Button } from '@calendly/ui/components/button'
import { useCallback } from 'react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useDispatch, useSelector } from 'react-redux'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { Link } from '@calendly/ui/components/link'
import { GoogleLogin, useGoogleOneTapLogin } from '@react-oauth/google'
import { showError } from '@calendly/alert'
import Marked from 'marked-react'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import { redirectToAuthorizeUrl } from 'actions/omniauth'
import { getOmniAuthPath } from 'services/authentication_service'
import { customDomainSelector } from 'selectors/custom_domain'
import { useMeetingTypesPath } from 'hooks/use_meeting_types_path'
import { useStatsigExperimentGroupName } from 'hooks/use-statsig-experiment-group-name'
import { useEventType } from 'components/use_event_type'
import { useStatsigLayer } from 'hooks/use-statsig-layer'
import { useInviteeSignUp } from 'hooks/useInviteeSignUp'
import { useTracking } from 'components/sign_up_buttons/hooks/use_tracking'
import { BUCKETS } from 'actions/email_provider'
import { emailProviderValueSelector } from 'selectors/email_provider'

import { MXRecordExperiment } from './experiment'
import GoogleIcon from './logos/google.svg'
import MicrosoftIcon from './logos/microsoft.svg'
import _FooterContainer from "index-FooterContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=FooterContainer";
import _FlexContainer from "index-FlexContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=FlexContainer";
import _SignupContainer from "index-SignupContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=SignupContainer";
import _ButtonContainer from "index-ButtonContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=ButtonContainer";
import _SubtitleWrapper from "index-SubtitleWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=SubtitleWrapper";
import _OmniAuthButtonStyling from "index-OmniAuthButtonStyling.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=OmniAuthButtonStyling";
import _Logo from "index-Logo.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=Logo";
import _CssProp1_OmniAuthButtonStyling from "index-CssProp1_OmniAuthButtonStyling.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sso_confirmation_footer/index.js?styleId=CssProp1_OmniAuthButtonStyling";


const FooterContainer = /*#__PURE__*/styled('div', null, {
  displayName: "FooterContainer",
  styles: _FooterContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

const FlexContainer = /*#__PURE__*/styled('div', null, {
  displayName: "FlexContainer",
  styles: _FlexContainer
})

const SignupContainer = /*#__PURE__*/styled('div', null, {
  displayName: "SignupContainer",
  styles: _SignupContainer
})

const ButtonContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

const SubtitleWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "SubtitleWrapper",
  styles: _SubtitleWrapper
})

const OmniAuthButtonStyling = /*#__PURE__*/styled(Button, null, {
  displayName: "OmniAuthButtonStyling",
  styles: _OmniAuthButtonStyling,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

const Logo = /*#__PURE__*/styled('img', null, {
  displayName: "Logo",
  styles: _Logo
})

const OmniAuthButton = ({ provider, children, email: encodedEmail, twoColumn, oneTap, width = 220 }) => {
  const dispatch = useDispatch()
  const track = useTracking()
  const { enabled: customDomainEnabled, default_domain: defaultDomain } = useSelector(customDomainSelector)
  const meetingTypesRoute = useMeetingTypesPath()
  const redirectUrl = `${defaultDomain || window.location.origin}${meetingTypesRoute}`
  const path = getOmniAuthPath(provider, 'signup', { email: undefined, booking_redirect: redirectUrl, section: 'booking' })
  const signup = useCallback(
    () => {
      dispatch(redirectToAuthorizeUrl(
        path,
        () => track('CTA Clicked', {
          cta_text: provider === 'google_oauth2' ? 'google_oauth' : 'msft_oauth',
          cta_key: 'booking_page_confirmation',
        })
      ))
    },
    [path, dispatch, track, provider]
  )

  const props = customDomainEnabled
    ? { as: 'a', href: `${defaultDomain}/app/register_oauth_redirect?provider=${provider}&email=${encodedEmail}&section=booking` }
    : { onClick: signup }


  return (
    <OmniAuthButtonStyling
      decoration="secondary-outline"
      size="small"
      twoColumn={twoColumn}
      oneTap={oneTap}
      css={[_CssProp1_OmniAuthButtonStyling, [["a1n8rhzl", width, "px"], ["aema2g0", width, "px"], ["a1o83pzm", width, "px"]]]}
      {...props}
    >
      {children}
    </OmniAuthButtonStyling>
  )
}

const determineWidth = (twoColumn, isPhone, isTabletDown) => {
  if (twoColumn && isPhone) return 313
  if (twoColumn && isTabletDown) return 279
  if (isPhone) return 345
  return 220
}

const SignupContent = ({ twoColumn }) => {
  const { signUpByEmailPath: href, encodedEmail: email } = useInviteeSignUp()
  const { i18n } = useI18n()
  const track = useTracking()

  const dispatch = useDispatch()
  const isPhone = useDeviceType('isPhone')
  const isTabletDown = useDeviceType('isTabletDown')
  const oneTapGroupName = useStatsigExperimentGroupName('growth_booking_flow_google_1_tap')
  const confirmationLayer = useStatsigLayer('booking_flow_confirmation')
  const personalizedSignInWithGoogle = confirmationLayer.get('personalized_sign_in_with_google')
  const signInWithGoogle = oneTapGroupName === 'variant_1' || personalizedSignInWithGoogle
  const provider = useSelector(emailProviderValueSelector)
  const mxExperiment = confirmationLayer.get('mx_confirmation')
  const disableOneTap = oneTapGroupName === 'control' || oneTapGroupName === null || mxExperiment || personalizedSignInWithGoogle
  const width = determineWidth(twoColumn, isPhone, isTabletDown)

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      track('CTA Clicked', {
        cta_text: 'google_popup',
        cta_key: 'booking_page_confirmation',
      })
      window.location.href = `/users/auth/google_onetap?credential=${credentialResponse.credential}`
    },
    onError: () => {
      track('CTA Clicked', {
        cta_text: 'google_popup',
        cta_key: 'booking_page_confirmation',
      })
      dispatch(showError(i18n.t('errors.default_no_action')))
    },
    use_fedcm_for_prompt: true,
    disabled: disableOneTap
  })

  const googleButton = signInWithGoogle ? (
    <GoogleLogin
      shape="pill"
      width={width}
      scope="email profile https://www.googleapis.com/auth/calendar"
      click_listener={() => track('CTA Clicked', {
        cta_text: 'google_button',
        cta_key: 'booking_page_confirmation',
      })}
      onSuccess={(credentialResponse) => {
        window.location.href = `/users/auth/google_onetap?credential=${credentialResponse.credential}`
      }}
      onError={() => dispatch(showError(i18n.t('errors.default_no_action')))}
      use_fedcm_for_prompt
    />
  ) : (
    <OmniAuthButton width={width} provider="google_oauth2" email={email} twoColumn={twoColumn}>
      <Logo src={GoogleIcon} alt="Google" />
      <BodyText size="medium">{i18n.t('booking.templates.signup_form.sign_up_with_google')}</BodyText>
    </OmniAuthButton>
  )

  const microsoftButton = (
    <OmniAuthButton width={width} provider="azure2_oauth2" email={email} twoColumn={twoColumn} oneTap={signInWithGoogle}>
      <Logo src={MicrosoftIcon} alt="Microsoft" />
      <BodyText size="medium">{i18n.t('booking.templates.signup_form.sign_up_with_microsoft')}</BodyText>
    </OmniAuthButton>
  )

  // Show buttons based on email provider experiment
  const showGoogleButton = !mxExperiment || !provider || provider === BUCKETS.GOOGLE
  const showMicrosoftButton = !mxExperiment || !provider || provider === BUCKETS.MICROSOFT

  return (
    <SignupContainer>
      <ButtonContainer twoColumn={twoColumn}>
        {showGoogleButton && googleButton}
        {showMicrosoftButton && microsoftButton}
      </ButtonContainer>
      <Link
        underline={false}
        href={href}
        onClick={() => track('CTA Clicked', {
          cta_text: 'email_password',
          cta_key: 'booking_page_confirmation',
        })}
      >
        {i18n.t('booking.templates.signup_form.sign_up_with_email')}
      </Link>
    </SignupContainer>
  )
}

const checkIfIframe = () => window.location !== window.parent.location

const getTitleAndSubtitle = ({ variant, isTwoColumnDesign }) => {
  switch (variant) {
    case 'free_notes':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_1.footer_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_1.footer_subtitle'
      }
    case 'capture_notes_signup':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_2.footer_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_2.footer_subtitle'
      }
    case 'capture_notes_benefits':
      return {
        titleKey: 'booking.templates.signup_form.notetaker_discovery_variant_3.footer_title',
        subtitleKey: 'booking.templates.signup_form.notetaker_discovery_variant_3.footer_subtitle'
      }
    case 'link':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link.footer_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link.footer_subtitle'
      }
    case 'link_animated':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.footer_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.footer_subtitle'
      }
    case 'icons':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_icons.footer_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_icons.footer_subtitle'
      }
    case 'social_proof':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.footer_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.footer_subtitle'
      }
    default:
      return isTwoColumnDesign ? {
        titleKey: 'booking.templates.signup_form.try_calendly_for_your_meetings',
        subtitleKey: 'booking.templates.signup_form.build_your_schedule'
      } : {
        titleKey: 'booking.templates.signup_form.scheduled_with_calendly',
        subtitleKey: 'booking.templates.signup_form.eliminate_back_and_forth'
      }
  }
}

export const ConfirmationFooter = ({ variant }) => {
  const { i18n } = useI18n()
  const isEmbedded = checkIfIframe()
  const eventType = useEventType()
  const isTwoColumnDesign = useStatsigLayer('booking_flow_confirmation').get('confirmation_page_two_column_design')

  if (eventType?.unbranded || isEmbedded) return null

  const { titleKey, subtitleKey } = getTitleAndSubtitle({ variant, isTwoColumnDesign })
  const title = i18n.t(titleKey)
  const subtitle = i18n.t(subtitleKey)

  const titleTextLevel = isTwoColumnDesign ? 3 : 4
  const subtitleTextLevel = isTwoColumnDesign ? 4 : 5

  return (
    <FooterContainer twoColumn={isTwoColumnDesign}>
      {(!!title || !!subtitle) && (
        <FlexLayout direction="column" gap={8}>
          <TitleText level={titleTextLevel}><Marked>{title}</Marked></TitleText>
          <SubtitleWrapper animated={variant === 'link_animated'}>
            <TitleText level={subtitleTextLevel} variant="normal"><Marked>{subtitle}</Marked></TitleText>
          </SubtitleWrapper>
        </FlexLayout>
      )}
      <FlexContainer>
        <MXRecordExperiment>
          <SignupContent twoColumn={isTwoColumnDesign} />
        </MXRecordExperiment>
      </FlexContainer>
    </FooterContainer>
  )
}
